<script>
  import { Icons } from "../lib/Icon/Icons";
  import Icon from "../lib/Icon/Icon.svelte";

  export let canvasId;

  $: optionsOpen = false;

  const toggleOptions = () => optionsOpen = !optionsOpen;

  const options = [{
    name: "Download Image",
    icon: Icons.Download,
    action: () => {
      const canvas = document.getElementById(canvasId);
      // @ts-ignore
      canvas.toBlob(blob => {
        const link = document.createElement("a");
        link.download = "bitcoin-dominance.png";
        const url = URL.createObjectURL(blob);
        link.onload = () => URL.revokeObjectURL(url);
        link.href = url;
        link.click();
      })

      toggleOptions();
    }
  }];
</script>

<div class="relative">
  <div role="button" class="cursor-pointer" on:click={toggleOptions} on:keydown={toggleOptions} tabindex="0">
    <Icon iconType={Icons.Image} />
  </div>

  <div class="{optionsOpen ? "opacity-100" : "opacity-0 pointer-events-none"} absolute top-11 right-0 bg-white border rounded-lg max-h-40 overflow-scroll">
    {#each options as option}
      <div class="relative text-sm font-semibold text-neutral-1100 flex items-center gap-x-1.5 border px-2 py-2.5 hover:bg-primary-100 cursor-pointer whitespace-nowrap" on:click={option.action} on:keydown={option.action}>
        <Icon iconType={option.icon} />
        {option.name}
      </div>
    {/each}
  </div>
</div>
